"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AppointmentCancel;
var _react = _interopRequireDefault(require("react"));
var _xstate = require("xstate");
var _react2 = require("@xstate/react");
var _propTypes = require("prop-types");
var _MountScroller = _interopRequireDefault(require("../../../components/Util/MountScroller"));
var _xstate2 = require("../../lib/constants/xstate");
var _utils = require("../../lib/utils");
var _styles = require("./styles");
var _Shimmer = _interopRequireDefault(require("../../../components/Loading/Provider/Shimmer"));
var _CancelPage = _interopRequireDefault(require("../CancelPage"));
var _ConfirmationPage = _interopRequireDefault(require("../ConfirmationPage"));
var _ErrorPage = require("../ErrorPage");
function AppointmentCancel(_ref) {
  let {
    service,
    ...props
  } = _ref;
  const [currentState] = (0, _react2.useService)(service);
  return /*#__PURE__*/_react.default.createElement(_styles.Container, null, (0, _utils.pendingStateMatchHelper)(currentState) && /*#__PURE__*/_react.default.createElement(_Shimmer.default, null), (0, _utils.subStateMatchHelper)(_xstate2.states.error, currentState) && /*#__PURE__*/_react.default.createElement(_ErrorPage.ErrorPage, null), currentState && currentState.matches(_xstate2.states.cancelDisabled) && /*#__PURE__*/_react.default.createElement(_ErrorPage.ErrorPageCancelDisabled, {
    service: service
  }), currentState && currentState.matches(_xstate2.states.cancelPage) && /*#__PURE__*/_react.default.createElement(_CancelPage.default, {
    service: service,
    track: props.track
  }), (0, _utils.canceledStateMatchHelper)(currentState) && /*#__PURE__*/_react.default.createElement(_MountScroller.default, {
    alignToTop: true
  }, ref => /*#__PURE__*/_react.default.createElement(_ConfirmationPage.default, {
    createRescheduleLink: props.createRescheduleLink,
    ref: ref,
    searchProvidersLink: props.searchProvidersLink,
    service: service,
    track: props.track
  })));
}
AppointmentCancel.propTypes = {
  /**
   * Callback that takes a providerId and returns a URL to be used as a hyperlink to reschedule with the appointment provider
   * @callback createRescheduleLink
   * @param {number} providerId
   */
  createRescheduleLink: _propTypes.func.isRequired,
  /**
   * The interpreted appointmentCancelMachine that will handle the logic for this component
   */
  service: (0, _propTypes.instanceOf)(_xstate.Interpreter).isRequired,
  /**
   * Callback triggered for tracking
   * @callback track
   * @param {string} eventName
   * @param {object} eventData
   */
  track: _propTypes.func.isRequired,
  /**
   * URL link for the `Search Providers` button.
   */
  searchProvidersLink: _propTypes.string.isRequired
};
AppointmentCancel.defaultProps = {};
AppointmentCancel.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppointmentCancel",
  "props": {
    "createRescheduleLink": {
      "description": "Callback that takes a providerId and returns a URL to be used as a hyperlink to reschedule with the appointment provider\n@callback createRescheduleLink\n@param {number} providerId",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "service": {
      "description": "The interpreted appointmentCancelMachine that will handle the logic for this component",
      "type": {
        "name": "instanceOf",
        "value": "Interpreter"
      },
      "required": true
    },
    "track": {
      "description": "Callback triggered for tracking\n@callback track\n@param {string} eventName\n@param {object} eventData",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "searchProvidersLink": {
      "description": "URL link for the `Search Providers` button.",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};